var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1409 17.5312C21.3965 16.7812 19.5937 15.6867 18.719 15.2456C17.58 14.6718 17.4862 14.6249 16.5909 15.2901C15.9937 15.734 15.5967 16.1306 14.8978 15.9815C14.1989 15.8324 12.6801 14.992 11.3503 13.6663C10.0204 12.3407 9.13121 10.7779 8.98167 10.0813C8.83214 9.38478 9.23527 8.99244 9.67496 8.39385C10.2946 7.5501 10.2478 7.40947 9.71808 6.27041C9.30511 5.38447 8.17871 3.59853 7.42589 2.85791C6.62058 2.06244 6.62058 2.20306 6.10167 2.41869C5.67922 2.59643 5.27394 2.81249 4.89089 3.06416C4.14089 3.56244 3.72464 3.97635 3.43355 4.59838C3.14246 5.22041 3.01167 6.67869 4.51496 9.40963C6.01824 12.1406 7.07292 13.537 9.25589 15.7138C11.4389 17.8907 13.1175 19.0612 15.5714 20.4374C18.607 22.1376 19.7714 21.8062 20.3953 21.5156C21.0192 21.2249 21.435 20.8124 21.9342 20.0624C22.1865 19.68 22.403 19.2752 22.5811 18.8531C22.7971 18.336 22.9378 18.336 22.1409 17.5312Z",
    stroke: "#505762",
    strokeWidth: 1.52,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7d0cc72891589c66bbcf7eacdeb1b9c8.svg";
export { ForwardRef as ReactComponent };